import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchgrouptripstour = async () => {
  try {
    const response = await fetch(`${API_URL}/grouptripstour_list`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("City API Error:", error);
    return null;
  }
};
